import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRightIcon, HomeIcon } from '@heroicons/react/24/outline';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

const routeLabels: Record<string, string> = {
  '': 'Dashboard',
  'alunos': 'Alunos',
  'empresas': 'Empresas',
  'instituicoes': 'Instituições',
  'cursos': 'Cursos',
  'cidades': 'Cidades',
  'seguradoras': 'Seguradoras',
  'estagios': 'Estágios',
  'horarios': 'Horários',
  'relatorios': 'Relatórios',
  'gerar-termo': 'Termos de Estágio',
  'novo': 'Novo',
  'nova': 'Nova',
  'editar': 'Editar',
};

export const Breadcrumbs: React.FC = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  const getBreadcrumbs = (): BreadcrumbItem[] => {
    const breadcrumbs: BreadcrumbItem[] = [
      { label: 'Início', href: '/' }
    ];

    let currentPath = '';
    pathnames.forEach((segment, index) => {
      currentPath += `/${segment}`;
      
      // Pular IDs numéricos
      if (!isNaN(Number(segment))) {
        return;
      }

      const label = routeLabels[segment] || segment.charAt(0).toUpperCase() + segment.slice(1);
      
      // Último item não tem link
      if (index === pathnames.length - 1) {
        breadcrumbs.push({ label });
      } else {
        breadcrumbs.push({ label, href: currentPath });
      }
    });

    return breadcrumbs;
  };

  const breadcrumbs = getBreadcrumbs();

  // Não mostrar breadcrumbs na home
  if (location.pathname === '/') {
    return null;
  }

  return (
    <nav className="flex mb-4" aria-label="Breadcrumb">
      <ol className="inline-flex items-center space-x-1 md:space-x-3">
        {breadcrumbs.map((breadcrumb, index) => (
          <li key={index} className="inline-flex items-center">
            {index > 0 && (
              <ChevronRightIcon className="w-4 h-4 text-gray-400 mx-1" />
            )}
            {breadcrumb.href ? (
              <Link
                to={breadcrumb.href}
                className="inline-flex items-center text-sm font-medium text-gray-700 hover:text-primary-600 transition-colors"
              >
                {index === 0 && <HomeIcon className="w-4 h-4 mr-1" />}
                {breadcrumb.label}
              </Link>
            ) : (
              <span className="inline-flex items-center text-sm font-medium text-gray-500">
                {breadcrumb.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};
